import type { Eip1193Provider } from "./eip1193";
import { httpReadProvider, httpBatchReadProvider, readRpcUrl } from "./http-read-provider";

let cached: { url: string; provider: Eip1193Provider } | null = null;
export function configuredElysiumMintProvider(signal?: AbortSignal): Eip1193Provider | null {
  const url = configuredElysiumRpcUrl();
  return url ? httpBatchReadProvider(url, "ELYSIUM_MINT", signal) : null;
}

/** Operation-local batch transport for swap preflight reads. The wallet provider
 * remains responsible only for prompting/signing/broadcasting the prepared tx. */
export function configuredElysiumTradeProvider(signal?: AbortSignal): Eip1193Provider | null {
  const url = configuredElysiumRpcUrl();
  return url ? httpBatchReadProvider(url, "ELYSIUM_TRADE", signal) : null;
}
/** Explicit read-only transport. No default RPC and no account/sign/send methods. */
export function configuredElysiumRpcUrl(): URL | null {
  return readRpcUrl(import.meta.env.VITE_ELYSIUM_RPC_URL);
}

export function configuredElysiumReadProvider(signal?: AbortSignal): Eip1193Provider | null {
  const url = configuredElysiumRpcUrl();
  if (!url) return null;
  if (!signal && cached?.url === url.href) return cached.provider;
  const provider = httpReadProvider(url, "ELYSIUM", signal);
  // A quote's cancellation must not affect the shared balance/read provider.
  if (!signal) cached = { url: url.href, provider };
  return provider;
}
